var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlasmaPistol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.581 21.723L23.515 19.2165C23.515 19.2165 23.2825 17.7045 23.302 17.4705C23.3215 17.2365 23.8225 15.066 24.0145 14.6655C24.2065 14.265 24.7225 13.1685 24.763 12.969C24.8035 12.7695 25.411 10.2465 25.4785 10.0845C25.546 9.9225 26.407 7.7475 28.27 6.84C30.133 5.9325 31.75 5.232 33.097 5.0505C34.444 4.869 36.6925 4.797 37.204 4.8075C37.7155 4.818 49.147 5.1945 49.147 5.1945V4.575C49.147 4.575 54.2155 4.1925 56.3095 3.6795C58.4035 3.1665 64.4545 1.3725 64.627 1.338C64.7995 1.3035 64.9465 0.892496 65.533 1.2525C66.121 1.6125 71.446 5.8695 71.446 5.8695L75.2065 6.1065C75.2065 6.1065 80.668 7.0005 81.667 7.41C82.666 7.8195 86.143 10.3755 86.143 10.3755L86.818 10.1505L88.339 11.478L87.832 12.234C87.832 12.234 89.9155 13.893 89.9155 14.8665V18.936L92.788 20.118C92.788 20.118 92.3875 22.4265 92.8975 22.9335L92.7325 24.285L93.5365 27.4545L93.295 28.8465C93.295 28.8465 93.634 31.197 93.214 33.0195C92.794 34.842 91.516 38.124 91.048 39.012C90.58 39.9 86.425 46.8315 86.425 46.8315L84.229 47.8245L81.019 45.882L80.383 44.2365L79.33 43.095C79.33 43.095 78.6655 43.041 78.316 42.6135C77.9665 42.186 76 39.267 76.1155 38.5335C76.2325 37.8015 77.0935 36.4185 77.9305 36.378L78.766 36.3375C78.766 36.3375 79.939 36.225 80.0545 35.5485C80.17 34.8735 80.146 33.8865 80.2435 33.1125C80.341 32.3385 81.211 31.4265 81.406 31.14C81.601 30.8535 82.126 30.2745 81.9925 29.4075C81.859 28.539 80.5675 26.145 80.5675 26.145L78.427 20.682C78.427 20.682 77.7805 21.1755 77.245 20.907C76.7095 20.6385 76.4515 19.9695 74.455 19.833C72.4585 19.6965 70.129 19.731 69.52 19.926C68.911 20.1195 68.2855 20.6835 68.2855 20.6835L67.2775 21.204C67.2775 21.204 66.8455 22.938 66.6025 23.331C66.3595 23.724 65.803 24.468 65.803 24.468L64.663 28.4325C64.663 28.4325 64.9345 29.0055 64.8235 29.694C64.7125 30.3825 61.5925 38.1975 61.5925 38.1975L62.8375 39.0225L67.0645 40.2435L67.5085 41.547L68.857 41.7105L70.2115 40.4745C70.2115 40.4745 71.617 40.1685 72.658 41.688C73.699 43.209 75.415 49.4235 75.415 49.4235C75.415 49.4235 75.8215 50.9145 75.7855 51.993C75.751 53.0715 75.331 54.978 75.331 54.978C75.331 54.978 72.8635 56.6595 71.7835 57.099C70.7035 57.5385 67.648 58.278 67.0645 58.443C66.481 58.608 60.8035 58.413 60.8035 58.413C60.8035 58.413 59.3515 56.544 58.6675 56.16C57.9835 55.776 57.0355 55.017 56.47 55.335C55.9045 55.653 53.464 55.647 53.464 55.647L51.466 55.116L49.147 54.075C49.147 54.075 48.505 51.936 47.5675 51.4485C46.63 50.961 45.5845 50.4675 44.0155 50.4315C42.4465 50.397 40.828 50.796 39.6505 50.235C38.473 49.674 36.46 47.3775 36.46 47.3775C36.46 47.3775 35.338 45.21 34.8115 44.6565C34.285 44.1015 31.723 41.9985 30.901 40.8255C30.079 39.6525 28.27 36.7305 28.2895 36.0555C28.309 35.3805 26.314 32.9895 25.3735 32.3385C24.433 31.689 23.5195 31.1775 23.2915 30.3675C23.0635 29.5575 23.1325 28.734 22.906 27.945C22.6795 27.1575 21.9475 24.567 21.9475 24.567C21.9475 24.567 22.849 24.4545 23.6365 24.9045C24.4255 25.3545 24.0385 25.338 24.9925 25.4175C25.9465 25.497 28.4515 25.728 30.1105 25.506C31.7695 25.284 35.6215 24.591 36.5875 24.6015C37.555 24.6135 39.2395 24.894 39.31 25.7205C39.3805 26.547 39.4585 27.0435 39.4585 27.0435L45.1465 33.294C45.1465 33.294 47.4595 29.5635 47.8375 28.845C48.2155 28.1265 49.315 25.524 49.657 24.0165C49.999 22.509 50.551 19.947 50.551 19.947L44.0185 18.258L43.0045 16.3995L40.597 15.798L39.175 17.076C39.175 17.076 37.0915 17.004 36.5845 16.6455C36.0775 16.287 35.233 16.3995 35.233 16.3995L31.9105 16.6245L26.0545 20.1165L25.2235 21.0885L23.5765 21.7215L23.581 21.723Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2934 14.667C68.9719 14.667 69.5219 14.117 69.5219 13.4385C69.5219 12.76 68.9719 12.21 68.2934 12.21C67.615 12.21 67.0649 12.76 67.0649 13.4385C67.0649 14.117 67.615 14.667 68.2934 14.667Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8564 17.7794C69.027 17.7794 69.1654 17.6411 69.1654 17.4704C69.1654 17.2998 69.027 17.1614 68.8564 17.1614C68.6857 17.1614 68.5474 17.2998 68.5474 17.4704C68.5474 17.6411 68.6857 17.7794 68.8564 17.7794Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9899 7.61694L52.8079 9.08994",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.517 7.61694L51.3335 9.08994",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9899 11.5589L52.8079 10.0844",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.517 11.5589L51.3335 10.0844",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2739 4.46246H69.7454",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.74 18.1574C84.74 18.1574 84.9065 22.9334 87.158 22.9334C89.4095 22.9334 92.3945 20.9624 92.3945 20.9624",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1355 31.4474L39.3845 26.5469",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2046 8.62506C37.2181 8.62506 37.2046 16.4011 37.2046 16.4011",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.78 17.4704C50.78 17.4704 50.3705 20.7359 52.3775 21.2999L51.9245 24.0029L49.823 24.5654",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9355 23.6084L65.478 22.2569L65.9355 20.2874L67.065 19.2164",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2798 41.5169L67.9563 46.4159H69.5223L70.1523 42.1919L72.4608 42.0794",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2802 42.0225C67.2802 42.0225 57.9127 42.2475 51.3337 39.432C44.7547 36.6165 37.5757 27.1275 37.5757 27.1275",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9019 29.6909C31.0144 29.8604 34.7869 36.0539 35.8009 37.3499C36.8149 38.6444 37.6024 40.0529 40.8124 40.7279",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3013 29.6891L36.3008 29.6877C36.1603 29.2665 35.7049 29.039 35.2837 29.1795L33.8395 29.6613C33.4183 29.8019 33.1907 30.2572 33.3312 30.6785L33.3317 30.6799C33.4722 31.1011 33.9276 31.3286 34.3488 31.1881L35.7931 30.7063C36.2143 30.5657 36.4418 30.1104 36.3013 29.6891Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8269 32.28L37.8265 32.2786C37.6859 31.8574 37.2306 31.6298 36.8093 31.7703L35.3651 32.2522C34.9439 32.3927 34.7163 32.8481 34.8569 33.2693L34.8574 33.2707C34.9979 33.6919 35.4533 33.9195 35.8745 33.779L37.3187 33.2971C37.7399 33.1566 37.9675 32.7012 37.8269 32.28Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7163 41.5169C39.7163 41.5169 42.3353 42.3329 43.1798 43.3469C44.0243 44.3609 43.9403 45.4589 44.6573 46.1339C45.3758 46.8089 48.5858 47.8649 48.5858 47.8649C48.5858 47.8649 49.6418 48.3299 50.1908 49.1744C50.7398 50.0189 51.0353 50.8634 51.6263 51.4124C52.2173 51.9614 52.8518 52.2989 53.7803 52.4264C54.7088 52.5539 56.8628 51.4979 58.9748 52.4264C61.0868 53.3549 61.0013 54.6224 63.4088 55.3409C65.8163 56.0594 67.9253 55.8899 67.9253 55.8899",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6029 46.8315C41.1281 46.8315 41.5539 46.4057 41.5539 45.8805C41.5539 45.3553 41.1281 44.9295 40.6029 44.9295C40.0776 44.9295 39.6519 45.3553 39.6519 45.8805C39.6519 46.4057 40.0776 46.8315 40.6029 46.8315Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2864 39.714C85.7992 39.714 86.2149 39.2983 86.2149 38.7855C86.2149 38.2727 85.7992 37.857 85.2864 37.857C84.7736 37.857 84.3579 38.2727 84.3579 38.7855C84.3579 39.2983 84.7736 39.714 85.2864 39.714Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2841 29.4044C88.8226 29.4044 89.2591 28.9679 89.2591 28.4294C89.2591 27.8909 88.8226 27.4544 88.2841 27.4544C87.7456 27.4544 87.3091 27.8909 87.3091 28.4294C87.3091 28.9679 87.7456 29.4044 88.2841 29.4044Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7847 17.1329L89.6932 17.4704",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1355 15.9509L24.4835 17.7809H26.1725L29.945 14.6654L40.307 15.7259",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.956 15.6899C46.1838 15.6899 46.3685 15.5052 46.3685 15.2774C46.3685 15.0496 46.1838 14.8649 45.956 14.8649C45.7281 14.8649 45.5435 15.0496 45.5435 15.2774C45.5435 15.5052 45.7281 15.6899 45.956 15.6899Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2288 21.0885L23.5818 21.7215C23.5818 21.7215 23.6388 19.947 23.5818 19.497C23.5248 19.047 22.9623 18.0885 23.5818 15.9495C24.2013 13.8105 24.3708 14.316 24.7083 13.1895C25.0458 12.063 24.9903 8.57248 28.5933 6.65698C32.1978 4.74298 34.9008 4.79848 36.6453 4.79848C38.3898 4.79848 49.1463 5.19298 49.1463 5.19298V4.57348C49.1463 4.57348 55.6788 3.95398 57.6498 3.39148C59.6208 2.82898 64.8573 1.02598 65.5338 1.25098C66.2103 1.47598 71.4468 5.86798 71.4468 5.86798C71.4468 5.86798 81.3018 5.98048 84.3423 8.90848C87.3828 11.8365 86.1438 10.3725 86.1438 10.3725L86.8188 10.1475L88.3398 11.475L87.8328 12.231C87.8328 12.231 89.6343 13.3005 89.9163 15.8355C90.1983 18.369 89.9163 18.933 89.9163 18.933L92.7888 20.115C92.7888 20.115 92.5068 22.875 93.1263 23.268L92.7318 24.282C92.7318 24.282 93.6333 27.267 93.5763 27.942C93.5193 28.617 93.2943 29.124 93.2943 29.124C93.2943 29.124 93.9138 31.9395 92.3928 36.051C90.8718 40.1625 86.0853 47.313 86.0853 47.313L84.2268 47.82L80.7918 45.5115L80.6793 44.5545L79.3278 43.0905C79.3278 43.0905 79.3278 43.3725 78.5388 42.8085C77.7498 42.2445 76.6803 39.8805 76.6803 39.8805C76.6803 39.8805 75.7788 38.6985 76.2303 37.797C76.6803 36.8955 77.4693 36.333 78.3138 36.333H79.1583C79.1583 36.333 80.4528 34.9245 80.3973 33.9675C80.3418 33.0105 80.0028 32.9535 80.3403 32.334C80.6778 31.7145 82.3668 30.87 81.9168 28.7865C81.4668 26.703 80.5653 26.1405 80.5653 26.1405L78.4248 20.6775C78.4248 20.6775 77.7498 20.9595 77.2428 20.9025C76.7358 20.8455 76.5678 20.1705 74.4828 19.833C72.3993 19.4955 69.1893 19.833 68.9073 20.115C68.6253 20.397 67.9503 20.9595 67.9503 20.9595L66.9933 21.297C66.9933 21.297 66.8808 22.761 66.5988 23.3235C66.3168 23.886 65.8668 24.225 65.8668 24.225L64.5723 28.7295C64.5723 28.7295 64.9098 29.01 64.7973 29.9955C64.6848 30.981 61.5873 38.19 61.5873 38.19C61.5873 38.19 61.6443 38.64 62.5443 38.922C63.4458 39.204 67.1058 40.4985 67.1058 40.4985L67.2753 41.5125L69.1338 41.7375C69.1338 41.7375 69.9228 40.893 69.9228 40.443C69.9228 40.443 70.9923 40.5 71.7813 40.8375C72.5703 41.175 73.1328 42.5835 73.1328 42.5835C73.1328 42.5835 75.7233 49.059 75.7788 51.6495C75.8358 54.24 75.3288 54.972 75.3288 54.972C75.3288 54.972 72.7953 56.943 70.0923 57.732C67.3893 58.521 66.6003 58.689 65.2488 58.6335C63.8973 58.578 61.0248 58.464 60.7998 58.4085C60.5748 58.3515 59.5668 56.7195 58.6638 56.1555C57.7593 55.593 56.8023 55.1985 55.9578 55.3665C55.1133 55.536 54.4368 55.5915 53.6493 55.6485C52.8618 55.7055 49.3128 54.4095 49.1448 54.072C48.9753 53.7345 48.6378 51.819 46.9488 51.087C45.2598 50.355 43.2888 50.355 41.8803 50.412C40.4718 50.469 40.0218 50.469 38.8953 49.905C37.7688 49.3425 36.8118 48.441 36.5868 47.8215C36.3618 47.202 36.4743 46.6395 35.0658 44.949C33.6573 43.26 31.2933 41.6265 30.2793 39.993C29.2653 38.3595 27.5763 34.0245 26.3943 33.066C25.2123 32.109 23.7903 31.545 23.2908 30.363C22.7913 29.181 23.2968 28.9545 22.6788 27.153C22.0593 25.3515 21.9468 24.5625 21.9468 24.5625L23.6358 24.9L24.4248 25.35C24.4248 25.35 28.3098 25.857 31.3518 25.35C34.3923 24.843 37.7718 24.111 38.7843 25.0125C39.7983 25.914 39.1788 26.5335 39.4593 27.039C39.7413 27.546 45.1473 33.2895 45.1473 33.2895C45.1473 33.2895 48.6948 27.996 49.3143 25.4625C49.9338 22.929 50.5533 19.944 50.5533 19.944L44.0208 18.255L43.0068 16.3965L40.3038 15.7215L39.1773 17.073C39.1773 17.073 36.5868 17.016 36.0798 16.284L31.9128 16.6215L26.0568 20.1135L25.2258 21.0855L25.2288 21.0885Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1489 33.2955C45.1489 33.2955 47.9089 35.9985 48.8659 36.4485C49.8229 36.8985 58.6789 41.082 65.9359 40.089",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5552 19.9484L50.7802 17.4704H66.4927L67.9567 20.9624",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1224 19.8315L71.7844 17.133V11.8395C71.7844 11.8395 71.7814 9.98098 70.1224 9.92548C68.4634 9.86998 59.6209 9.92548 59.6209 9.92548L56.0734 13.191L41.4319 13.134L40.3054 15.7245",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4294 20.6805L80.5699 18.4275C80.5699 18.4275 85.2439 17.808 86.4259 18.4275C87.6079 19.047 87.8899 19.83 87.8899 19.83L89.9164 18.933",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5701 26.1435L83.4426 25.749H87.2151C87.2151 25.749 91.0446 25.242 90.8751 28.5645C90.7056 31.887 86.2581 31.0425 86.2581 31.0425L83.8371 31.1385L81.7131 30.6585",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3453 32.3369L82.9359 34.0259L86.9903 37.1234C86.9903 37.1234 88.7363 38.6834 87.8918 40.2404C87.0473 41.7974 84.2348 41.0654 84.2348 41.0654L81.0219 38.6999L78.3188 36.3344",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4263 33.2954L92.3963 36.0539",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8755 28.5644L93.2965 29.1269",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8899 40.2405L89.4109 41.685",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0991 5.53342C33.0991 5.53342 34.3381 8.06692 35.9716 8.46142C37.6051 8.85592 46.0516 8.91142 46.0516 8.91142L48.7546 7.22242H64.9156L65.9356 7.78492C65.9356 7.78492 70.8271 7.95442 71.3911 7.67242C71.9551 7.39042 71.4481 5.87092 71.4481 5.87092",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6574 6.3779C74.6574 6.3779 74.2074 11.6144 76.7409 12.6284C79.2744 13.6424 83.4984 13.4174 83.4984 13.4174",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6255 9.13647C74.6255 9.13647 75.389 8.80497 78.4295 9.89997C81.47 10.995 85.8065 13.8105 85.469 17.922",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5903 47.8229C36.5903 47.8229 37.9418 45.4574 38.4488 44.3594C38.9558 43.2614 38.7863 40.8599 40.8983 40.9619C43.0103 41.0639 43.8263 41.9099 45.1493 42.0779C46.4723 42.2474 49.0073 41.4869 51.3713 43.3454C53.7368 45.2039 53.5673 47.5694 55.1723 48.4139C56.7773 49.2584 59.4803 49.6814 61.8458 50.1884C64.2113 50.6954 64.7033 51.1169 65.9348 52.3844C67.1663 53.6519 68.7023 56.8784 67.4693 58.4399",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasmaPistol);
export default __webpack_public_path__ + "static/media/Plasma Pistol.ce4a5f4f782d016d6c3c34c69375c0d4.svg";
export { ForwardRef as ReactComponent };